import React from 'react';
import { Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentTooltiptLearningContinuumLevelMarkingInfo } from '../../Dashboard/Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip';
import {
  clssNameColumn,
  clssNameRow,
  currentMarking,
  initialMarking,
  stepMarking,
  styleColumn,
  styleRow
} from './Styles';

const LearningGrowthIcon = ({
  backgroundColor,
  currentCurriculum,
  lc,
  level,
  findLG,
  isLoading,
  direction = 'row',
  size,
  generalPosition,
  lgMin,
  lgMax
}) => {
  const clssName =
    direction === 'row'
      ? clssNameRow(generalPosition, lgMin, lgMax)
      : clssNameColumn(generalPosition, lgMin, lgMax);
  const width = size;
  const width2 = ['gscontinue', 'gscontinue/end'].includes(findLG?.typeGrowth) ? width - 6 : width - 3;
  const className2 = direction === 'row' ? 'items-center ' : 'justify-center ';

  return (
    <>
      {!isLoading && findLG && (
        <div className={`flex flex-col `}>
          <div
            style={
              direction === 'row'
                ? styleRow(width, generalPosition, lgMin, lgMax)
                : styleColumn(width, generalPosition, lgMin, lgMax)
            }
          />
          {/* <Tooltip
            arrow
            placement='right'
            title={
              <>
                <pre>
                  {JSON.stringify({ generalPosition, lgMin, lgMax, typeGrowth: findLG?.typeGrowth, lgType: lc.lgType }, null, 2)}
                </pre>
              </>
            }
          >
            <span className='flex items-center justify-center z-3'>{generalPosition}</span>
          </Tooltip> */}
          <div className={`flex ${clssName} ${className2} absolute inset-2`}>
            <Tooltip
              arrow
              placement='right'
              title={
                <ContentTooltiptLearningContinuumLevelMarkingInfo
                  lc={lc}
                  level={level}
                  marking={{
                    ...findLG,
                    markingDate: findLG.day ? new Date(findLG.day) : findLG.date,
                  }}
                  currentCurriculum={currentCurriculum}
                />
              }
            >
              <div
                className='flex items-center justify-center rounded-full w-full h-full  '
                style={{
                  width: width2,
                  height: width2,
                  opacity: [
                    'start/end',
                    'start',
                    'startdown',
                    'start/enddown',
                    // 'continue/start/end',
                    'continue/start',
                    'continue/start/continue',
                    'end',
                    'enddown',
                    'continue/end',
                    'gscontinue/end',
                    'current',
                    'gsend'
                  ].includes(findLG?.typeGrowth)
                    ? 1
                    : 0,
                  backgroundColor:
                    findLG && !['continue/level'].includes(findLG?.typeGrowth) && level.definition
                      ? backgroundColor
                      : 'transparent'
                }}
              >
                {findLG && !['continue/level'].includes(findLG?.typeGrowth) && level.definition && (
                  <FontAwesomeIcon
                    icon={
                      [
                        'start/end',
                        'start',
                        'startdown',
                        'start/enddown',
                        // 'continue/start/end',
                        'continue/start',
                        'continue/start/continue'
                      ].includes(findLG?.typeGrowth)
                        ? initialMarking
                        : ['end', 'enddown', 'continue/end', 'gscontinue/end', 'current', 'gsend'].includes(
                            findLG?.typeGrowth
                          )
                        ? currentMarking
                        : stepMarking
                    }
                    className='cursor-pointer text-right rounded-full  text-muted-foreground '
                    size={'2x'}
                    style={{
                      zIndex: 2,
                      width: width2 - 5,
                      height: width2 - 5,
                      transform:
                        // findLG?.typeGrowth.indexOf('down') > -1 ? 'scaleY(-1) rotate(180deg)' : 'none'
                        [
                          'start/end',
                          'start',
                          'startdown',
                          'start/enddown',
                          'continue/start/end',
                          'continue/start',
                          'continue/start/continue'
                        ].includes(findLG?.typeGrowth)
                          ? 'none'
                          : ['end', 'enddown', 'continue/end', 'gscontinue/end', 'current', 'gsend'].includes(
                              findLG?.typeGrowth
                            )
                          ? 'none'
                          : direction === 'row'
                          ? 'none'
                          : 'scaleY(-1) rotate(0.25turn)'
                    }}
                  />
                )}
              </div>
            </Tooltip>
          </div>
        </div>
      )}
    </>
  );
};

export default LearningGrowthIcon;
